import { BillingInvoiceEditService } from './billing-invoice-edit.service';
import { ClientFilter } from 'src/app/model/client-filter';
import { InvoiceNumberBookPoint } from 'src/app/model/invoice-number-book-point';
import { BillingInvoice } from 'src/app/model/billing/billing-invoice';
import { BillingInvoiceItemEditInfo } from 'src/app/model/billing/billing-invoice-item-edit-info';
import { BillingInvoiceCreateResponse } from 'src/app/model/billing/billing-invoice-create-response';
import { BillingInvoiceEditInfo } from 'src/app/model/billing/billing-invoice-edit-info';
import { ReportViewer } from 'src/app/model/report-viewer';
import { Injectable } from '@angular/core';
import { TaxType } from '../../../enums/tax-type.enum';
import { toFixedTrunc } from '../../../infrastructure/numeric-trunc';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { ClientSearch } from '../../../model/client-search';

@Injectable()
export class BillingInvoiceEntityEditService extends BillingInvoiceEditService {

    preBillingId: number;
    invoiceTypeId: number;
    sectorId: number;


    isVisibleCirculacionAbierta(): boolean {
      return this.invoiceTypeId !== InvoiceType.Debit;
    }


    isVisibleBillingInvoiceItemManual(): boolean {
      return false;
    }

    isVisibleDatesFromTo(): boolean {
      return false;
    }

    isVisibleBillingInvoiceItemEntity(): boolean {
      return true;
    }

    noDeleteItemManual(): boolean {
      return true;
    }

    isVisibleBillingInvoiceItemEntityCredit(): boolean {
      return false;
    }

    isVisibleBillingInvoiceAssociate(): boolean {
      return this.invoiceTypeId === InvoiceType.Debit;
    }

    isVisibleIsRejectedOptions(): boolean {
      return this.invoiceTypeId === InvoiceType.Debit;
    }

    setBillingInvoiceParams(sectorId: number, preBillingId: number, invoiceTypeId: number) {
      this.preBillingId = preBillingId;
      this.invoiceTypeId = invoiceTypeId;
      this.sectorId = sectorId;
    }

    setBillingInvoiceManualParams(sectorId: number, invoiceTypeId: number) {
      throw new Error('Method not implemented.');
    }

    setBillingInvoiceCreditParams(sectorId: number, billingInvoiceId: number) {
      throw new Error('Method not implemented.');
    }

    async billingInvoiceCreate( clientSearch: ClientSearch, invoiceNumberBookPoint: InvoiceNumberBookPoint,
      billingInvoice: BillingInvoice, medicalAppointmentProcedureExcludeIds: number[],
      items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoiceCreateResponse> {

        return await this.billingInvoiceEntityService.billingInvoiceCreate( this.preBillingId,
          clientSearch, invoiceNumberBookPoint, billingInvoice, medicalAppointmentProcedureExcludeIds,
          items);
    }

    getParentInvoiceCompleteNumber(): string {
       return `${ this.preBillingId }-${ new Date().getMilliseconds() }`;
    }

    getInvoiceTypeId(): number {
      return this.invoiceTypeId;
    }

    async getBillingInvoiceEditInfo(): Promise<BillingInvoiceEditInfo> {
      return await this.billingInvoiceEntityService.getBillingInvoiceEditInfo(this.preBillingId, this.sectorId);
    }

    async getBillingInvoiceReport(billingInvoiceId: number): Promise<ReportViewer> {
      return await this.billingInvoiceEntityService.getBillingInvoiceReport(billingInvoiceId);
    }

    async getBillingInvoiceItemEditInfos(): Promise<BillingInvoiceItemEditInfo[]> {
      return await this.billingInvoiceEntityService.getBillingInvoiceItemEditInfos(this.preBillingId);
    }

    async calculateBillingInvoice(
      billingInvoice: BillingInvoice,
      items: BillingInvoiceItemEditInfo[]): Promise<BillingInvoice> {

        const calculate = await this.billingInvoiceAmountService
        .calculateBillingInvoiceAmount(
          billingInvoice.ClientSearch,
          billingInvoice.InvoicePoint,
          items);

        billingInvoice.InvoiceTaxes = calculate.InvoiceTaxes;
        billingInvoice.Amount = calculate.Amount;
        billingInvoice.AmountWithTax = calculate.AmountWithTax;

        return billingInvoice;

    }
  }
